// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contents_wrapper__14Brs","commentCount":"contents_commentCount__2oD7T"};